import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  specialitiesWaitListState,
  lastLoadedDateState,
  specialityWaitListState,
  professionalWaitListState,
  showWaitListState,
} from "../state/atoms";
import { ServiceWaitList } from "src/services/agenda/waitlist";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";

export const useSpecialities = (dayDefaultAvailable) => {
  const [specialities, setSpecialities] = useRecoilState(
    specialitiesWaitListState
  );

  const specialitySelected = useRecoilValue(specialityWaitListState);
  const professionalSelected = useRecoilValue(professionalWaitListState);

  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);

  const setShowWaitList = useSetRecoilState(showWaitListState);

  useEffect(() => {
    const loadSpecialities = async () => {
      const date = dayDefaultAvailable?.toISOString().split("T")[0];

      setShowWaitList(false);

      try {
        if (specialitySelected.code === null && professionalSelected.code) {
          const response = await ServiceWaitList.getSpecialitiesByProfessional(
            professionalSelected.code
          );
          setSpecialities(response.data.data);
        } else {
          const professionalFilter = filterSearchSelected.professionalSelected;
          const specialityFilter = filterSearchSelected.specialitySelected;

          const filterValues =
            await ServiceWaitList.getSpecialitiesByProfessional(
              professionalFilter.code
            );
          console.log("filterValues", filterValues.data.data);

          // Obtener todas las especialidades
          const response = await ServiceWaitList.getSpecialities(date);
          console.log("response", response.data);

          // Filtrar las especialidades
          const filterSpecialities = response.data.filter((speciality) => {
            const matchesProfessional = filterValues.data.data.some(
              (filterSpeciality) =>
                filterSpeciality.esCodigo === speciality.espCodigo
            );

            const matchesSelectedSpeciality =
              specialityFilter &&
              specialityFilter.code === speciality.espCodigo;

            return matchesProfessional || matchesSelectedSpeciality;
          });
          console.log("filterSpecialities", filterSpecialities);

          // Mostrar la lista de espera si hay coincidencias
          if (filterSpecialities.length > 0) {
            setShowWaitList(true);
          }

          setSpecialities(response.data);
        }
      } catch (error) {
        console.error("Error loading specialities:", error);
      }
    };

    if (dayDefaultAvailable) {
      loadSpecialities();
    }
  }, [dayDefaultAvailable, setSpecialities]);

  return specialities;
};
